// icons
import { Polygon } from '@styled-icons/boxicons-regular'
import { Shapes } from '@styled-icons/fluentui-system-filled'
import { Rectangle } from '@styled-icons/boxicons-regular'

function WelcomeSection() {
	return (
		<section
			className='relative bg-white dark:bg-dark-300 flex flex-col items-center justify-center py-[62px]'
			id='welcome'
		>
			{/* shapes */}
			<Polygon className='absolute fill-yellow-100 top-[50px] left-[40px] w-[16px] h-[16px] sm:left-[88px] lg:left-[120px]' />
			<Polygon className='absolute fill-[#05FF00] bottom-[35px] right-[40px] w-[16px] h-[16px] sm:right-[68px] sm:bottom-[52px] lg:right-[214px]' />
			<Shapes className='absolute fill-transparent stroke-[#FF2E00] stroke-2 top-[68px] right-[44px] w-[16px] h-[16px] sm:right-[64px] lg:right-[84px]' />
			<Rectangle className='absolute fill-[#FF2E00] bottom-[108px] left-[24px] w-[16px] h-[16px] sm:left-[54px] rotate-45 sm:bottom-[50%]' />
			<Rectangle className='absolute -rotate-12 fill-yellow-100 top-[164px] right-[24px] w-[16px] h-[16px] sm:right-[36px]' />

			{/* sm */}
			<Shapes className='absolute invisible sm:visible fill-transparent stroke-[#FF2E00] stroke-2 bottom-[68px] left-[104px] w-[16px] h-[16px]' />

			{/* lg */}
			<Polygon className='absolute fill-yellow-100 bottom-[35px] right-[40px] w-[16px] h-[16px] sm:right-[68px] sm:bottom-[167px] lg:right-[128px]' />
			{/* end of shapes */}

			<p className='text-center text-[32px] w-[200px] sm:w-full font-bold leading-[44px] text-black dark:text-white'>
				Я <br className='sm:hidden' />
				Тимофей Ващенко <br className='hidden sm:block' />
				<span className='text-yellow-100'>Full-stack</span>{' '}
				<br className='sm:hidden' />
				Разработчик
			</p>
			<p className='text-dark-100 hidden sm:block mt-[18px] w-[440px] text-center'>
				Вот вам яркий пример современных тенденций - укрепление и
				развитие внутренней структуры играет важную роль в формировании
				системы обучения кадров, соответствующей насущным потребностям.
				Не следует, однако, забывать, что глубокий уровень погружения.
			</p>
			<button className='mt-[25px] bg-yellow-100 py-[16px] px-[32px] rounded-[5px] text-dark-400 font-medium text-[18px]'>
				Следить за мной
			</button>
		</section>
	)
}

export default WelcomeSection
